import React, { useState, useEffect } from "react";
import { ChatInputContainer, Button, ChatInput as StyledChatInput } from "@/views/styles";
import Icon from "@/components/Icon";
import styled from 'styled-components';
import { postRequest } from '@/utils'
import AudioRecorder from '@/components/chat/AudioRecorder';
import { useUser } from "../../hooks/useUser";

const HiddenFileInput = styled.input`
  display: none;
`;

const RecommendedPromptContainer = styled.div`
    display: flex;
    position: absolute;
    bottom: 4px;
`;

const StyledRecommendedPrompt = styled.div`
    display: flex;
    padding: 8px 16px;
    align-items: center;
    gap: 15px;
    border-radius: 34px;
    border: 1px solid var(--White-50, rgba(255, 255, 255, 0.05));
    background: rgba(0, 0, 0, 0.10);
    color: rgba(248, 248, 248, 0.65);
    font-size: ${props => props.isHalfScreen ? '9px' : '14px'};
    font-weight: 400;
    cursor: pointer;
    &:hover {
      border-radius: 34px;
      border: 1px solid var(--White-50, rgba(255, 255, 255, 0.05));
      background: rgba(0, 0, 0, 0.20);
      color: rgba(248, 248, 248, 0.65);
    font-weight: 400;
    }
`;

const StyledChatInputContainer = styled(ChatInputContainer)`
    background-color: #4E617B;
`;

const StyledButton = styled(Button)`
   margin-top: -43px;
`;
const ChatInput = ({ question, lesson, isContentPage, hiddenFileInput, textareaRef, inputValue, handleInputChange, handleKeyDown, messageLoading, sendFile, askModel, setMessageLoading, isHalfScreen, isAudioEnabled, sendMessage }) => {
    const [recordingState, setRecordingState] = useState('start');
    const [recommendedPrompts, setRecommendedPrompts] = useState([]);
    const { user, loading: isLoadingUser } = useUser();

    const loadRecommendedPrompts = async () => {
        if (user.id && user.id !== '') {

            const requestData = {
                user_id: user.id,
                context: question || "Common questions regarding fda regulations", // lesson?.context,
            }
            postRequest('/starter-prompts/gpt', JSON.stringify(requestData)).then((response) => {
                setRecommendedPrompts(response?.prompts);
            });
        }
    }

    useEffect(() => {
        loadRecommendedPrompts();
    }, [user.id, isLoadingUser, question]);

    const handleRecommendedPromptClick = (e, recommendedPrompt) => {
        sendMessage(recommendedPrompt, true)
    }
    return (
        <>
            {sendFile && hiddenFileInput &&
                <HiddenFileInput
                    type="file"
                    ref={hiddenFileInput}
                    onChange={(e) => {
                        e.preventDefault();
                        sendFile(e);
                    }}
                    accept=".pdf,.doc,.docx,.ppt,.pptx,.png,.jpg,.jpeg"
                />
            }

            <StyledChatInputContainer className={isContentPage ? "half" : "move"}>
                {/* {hiddenFileInput && <StyledButton onClick={() => hiddenFileInput.current.click()}><Icon name="attach"></Icon> </StyledButton>} */}
                <StyledChatInput
                    placeholder={recordingState === "generating" ? "Loading" : "Ask your question"}
                    value={messageLoading ? '' : inputValue}
                    ref={textareaRef}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown}

                />
                {isAudioEnabled && <AudioRecorder disabled={messageLoading} recordingState={recordingState} setRecordingState={setRecordingState} context={lesson?.context} askModel={askModel} setMessageLoading={setMessageLoading} />}
                <Button disabled={messageLoading} onClick={(e) => { sendMessage(e, true) }}><Icon name="upload"></Icon> </Button>

                <RecommendedPromptContainer>
                    {recommendedPrompts?.map((recommendedPrompt) => {
                        return (
                            <StyledRecommendedPrompt
                                isHalfScreen={isHalfScreen}
                                disabled={messageLoading}
                                key={recommendedPrompt}
                                role="button"
                                className="hidden md:flex"
                                onClick={(e) => handleRecommendedPromptClick(e, recommendedPrompt)}
                            >
                                {recommendedPrompt}
                            </StyledRecommendedPrompt>

                        )
                    })}
                </RecommendedPromptContainer>
            </StyledChatInputContainer>
        </>

    )
}

export default ChatInput;